








import {
  defineComponent,
  useContext,
  useFetch,
  ref,
} from '@nuxtjs/composition-api';
import { SfBreadcrumbs } from '@storefront-ui/vue';
import { useUiHelpers } from '~/composables';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import { Breadcrumb } from '~/modules/catalog/types';

export default defineComponent({
  components: { SfBreadcrumbs },
  setup() {
    const { getCatLink } = useUiHelpers();
    const { localePath, app: { i18n } } = useContext();

    const { categoryAncestors, isCategoryTreeLoaded, loadCategoryTree } = useTraverseCategory();
    const breadcrumbs = ref<Breadcrumb[]>([]);

    useFetch(async () => {
      if (!isCategoryTreeLoaded.value) {
        await loadCategoryTree();
      }
      const homebreadCrumbs = {
        text: i18n.t('Home') as string,
        link: localePath('/'),
      };
      breadcrumbs.value = categoryAncestors.value.map((category) => ({
        text: category.name,
        link: localePath(getCatLink(category)),
      }));
      breadcrumbs.value.unshift(homebreadCrumbs);
    });

    return {
      breadcrumbs,
    };
  },
});
